import React from 'react';
import Aerolineas from '../assets/logoAerolineas.svg';
import Flybondi from '../assets/logoFlybondi.svg';
import Jetsmart from '../assets/logoJetsmart.svg';

function AirlinesSection() {
  const airlines = [
    { name: 'Aerolíneas Argentinas', logo: Aerolineas },
    { name: 'flybondi', logo: Flybondi },
    { name: 'Jetsmart', logo: Jetsmart },
  ];

  return (
    <section className="bg-white py-8 md:py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-lg md:text-2xl font-bold font-montserrat text-[#1E3A5F] text-center mb-6 md:mb-12">
          TRABAJAMOS CON LAS MEJORES AEROLÍNEAS
        </h2>
        <div className="flex justify-center items-center gap-4 md:gap-8 flex-wrap">
          {airlines.map((airline, index) => (
            <div key={index} className="text-center opacity-70 hover:opacity-100 transition-opacity duration-300">
              <img 
                src={airline.logo} 
                alt={airline.name} 
                className="w-24 md:w-40 h-auto" 
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AirlinesSection;